import customers from "../../api/customers";

export default {
  namespaced: true,
  state: {
    items: [],
    secondItemsList: [],
    editedId: -1,
    users: [],
    uniqueContactDetails: null,
    editedItem: {
      buyingGroup: null,
      email: null,
      customerRelationDto: null,
      manualStatutCurrentYear: null,
      manualStatutPreviousYear: null,
      status: null,
      name: "",
      fK_UniqueContact: null,
      active: false,
      number: "",
      phone: "",
    },
    defaultItem: {
      buyingGroup: null,
      email: null,
      customerRelationDto: null,
      manualStatutCurrentYear: null,
      manualStatutPreviousYear: null,
      status: null,
      name: "",
      fK_UniqueContact: null,
      active: false,
      number: "",
      phone: "",
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        buyingGroup: item.buyingGroup,
        email: item.email,
        customerRelationDto: item.customerRelationDto,
        manualStatutCurrentYear: item.manualStatutCurrentYear,
        manualStatutPreviousYear: item.manualStatutPreviousYear,
        status: item.status,
        name: item.name,
        fK_UniqueContact: item.fK_UniqueContact,
        active: item.active,
        number: item.number,
        phone: item.phone,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    addOrRemoveACustomerRelation(state, customerRelations) {
      const customerId = state.editedId;
      state.editedItem.customerRelationDto = customerRelations.map(
        (relatedCustomer) => ({
          customerId: customerId,
          relatedCustomer: relatedCustomer,
        }),
      );
    },
    setExclusiveInterlocutor(state, exclusiveInterlocutor) {
      state.editedItem.fK_UniqueContact = exclusiveInterlocutor;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setSecondItemsList(state, items) {
      state.secondItemsList = items;
    },
    setUniqueContactDetails(state, details) {
      state.uniqueContactDetails = details;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return customers.get(data).then((response) => {
        commit("setItems", response.data);
        commit("setSecondItemsList", response.data);
        return response;
      });
    },
    // Cette fonction fait la même chose que fetchAll, mais permet de lier
    // les clients entre eux en stockant la réponse dans un état différent.
    fetchItems({ commit }, data) {
      return customers.get(data).then((response) => {
        commit("setSecondItemsList", response.data);
        return response;
      });
    },
    getCustomerWithDetails({ commit }, id) {
      return customers.getCustomerWithDetails(id).then((response) => {
        commit("setEditedId", response.data.id);
        commit("setEditedItem", response.data);
        return response;
      });
    },
    getLinkedUsers({ commit }, data) {
      return customers.getLinkedUsers(data).then((response) => {
        commit("setUsers", response.data);
        return response;
      });
    },
    saveLinkedUsers({ dispatch }, data) {
      return customers.saveLinkedUsers(data).then((response) => {
        dispatch("getLinkedUsers", data.id);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      return customers.store(state.editedItem).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      return customers
        .update(state.editedId, state.editedItem)
        .then((response) => {
          dispatch("fetchAll");
          return response;
        });
    },
    deleteItem(context, id) {
      return customers.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
    getUniqueContactDetails({ commit }, id) {
      return customers.getUniqueContactDetails(id).then((response) => {
        commit("setUniqueContactDetails", response.data);
        return response;
      });
    },
  },
};
